import styled from 'styled-components'
import { keyframes } from 'styled-components'
import { v } from '../../styles/variables'

export const SModalContainer = styled.div`
	position: fixed;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 40%;
	max-width: 700px; /* Limit maximum width */
	min-width: 280px; /* Ensure minimum width for smaller screens */
	background: ${({ theme }) => theme.bgf};
	padding: ${v.lgSpacing};
	border: 1px solid ${({ theme }) => theme.strongHighlight};
	display: grid;
	z-index: 1000;
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
	box-sizing: border-box;

	@media (max-width: 768px) {
		width: 90%;
		padding: ${v.smSpacing}; /* Reduce padding on mobile */
	}
`

export const SModalAddress = styled.div`
	display: flex;
	align-items: center; /* Vertically align text and icon */
	gap: 8px; /* Reduced space between text and icon for mobile */
`

export const SCopyIcon = styled.div`
	width: 40px; /* Reduced width for mobile */
	height: 30px;
	font-size: 20px; /* Reduced icon size for mobile */
	flex-shrink: 0; /* Prevent icon from shrinking */
	&:hover {
		color: ${({ theme }) => theme.highlight};
	}
	cursor: pointer;
`

export const SDivider = styled.div`
	height: 1px;
	width: 90%;
	background: ${({ theme }) => theme.bg3};
	margin: ${v.smSpacing} 0;
`

export const SAddressText = styled.p`
	word-break: break-all; /* Break long addresses to fit */
	margin: 0; /* Remove default margin */
	flex: 1; /* Take available space */
	font-size: 16px; /* Default font size */
	line-height: 1.4; /* Improve readability */

	@media (max-width: 768px) {
		font-size: 14px; /* Smaller font size on mobile */
	}

	@media (max-width: 400px) {
		font-size: 12px; /* Even smaller for very narrow screens */
	}
`
